import { FC } from 'react';
import { UnlockOutlined } from '@ant-design/icons';
import { ProButton } from '../antd';
import { BaseOperationButtonProps } from './interface';
import { ICON_COLLECTION } from '../constants/icon';

/** 解锁按钮 */
const UnLockButton: FC<BaseOperationButtonProps> = props => {
  const { children, text, icon, ...restProps } = props;
  return (
    <ProButton icon={icon} {...restProps}>
      {children || text}
    </ProButton>
  );
};

UnLockButton.defaultProps = {
  icon: ICON_COLLECTION.UNLOCK,
  text: '解锁',
};

export default UnLockButton;
